/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as PoliticasGetsempliceMotoristaRouteImport } from './routes/politicas/getsemplice-motorista'
import { Route as DocsPublicIdRouteImport } from './routes/docs/$publicId'
import { Route as AuthenticatedBackofficeRouteRouteImport } from './routes/_authenticated/backoffice/route'
import { Route as AuthenticatedSystemRouteRouteImport } from './routes/_authenticated/_system/route'
import { Route as AuthSigninIndexRouteImport } from './routes/auth/signin/index'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedBackofficeIndexRouteImport } from './routes/_authenticated/backoffice/index'
import { Route as AuthenticatedSystemIndexRouteImport } from './routes/_authenticated/_system/index'
import { Route as AuthenticatedSystemTenantRouteRouteImport } from './routes/_authenticated/_system/_tenant/route'
import { Route as AuthenticatedSystemCompanyRouteRouteImport } from './routes/_authenticated/_system/_company/route'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset/password/index'
import { Route as AuthenticatedBackofficeCustomersIndexRouteImport } from './routes/_authenticated/backoffice/customers/index'
import { Route as AuthenticatedSystemProfileIndexRouteImport } from './routes/_authenticated/_system/profile/index'
import { Route as AuthenticatedSystemDocumentsIndexRouteImport } from './routes/_authenticated/_system/documents/index'
import { Route as AuthenticatedSystemBuslineSchedulesIndexRouteImport } from './routes/_authenticated/_system/busline-schedules/index'
import { Route as AuthenticatedDocsDocumentRequestDocumentRequestIdRouteImport } from './routes/_authenticated/docs/document-request/$documentRequestId'
import { Route as AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRouteImport } from './routes/_authenticated/_system/busline-schedules/$buslineScheduleId'
import { Route as AuthenticatedBackofficeCustomersCustomerIdRouteRouteImport } from './routes/_authenticated/backoffice/customers/$customerId/route'
import { Route as AuthenticatedSystemTenantSettingsRouteRouteImport } from './routes/_authenticated/_system/_tenant/settings/route'
import { Route as AuthenticatedSystemCompanyCompanyRouteRouteImport } from './routes/_authenticated/_system/_company/company/route'
import { Route as AuthenticatedBackofficeCustomersCustomerIdIndexRouteImport } from './routes/_authenticated/backoffice/customers/$customerId/index'
import { Route as AuthenticatedSystemTenantSettingsIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/index'
import { Route as AuthenticatedSystemTenantNpsIndexRouteImport } from './routes/_authenticated/_system/_tenant/nps/index'
import { Route as AuthenticatedSystemTenantFleetsIndexRouteImport } from './routes/_authenticated/_system/_tenant/fleets/index'
import { Route as AuthenticatedSystemTenantDocumentRequestsIndexRouteImport } from './routes/_authenticated/_system/_tenant/document-requests/index'
import { Route as AuthenticatedSystemTenantCompaniesIndexRouteImport } from './routes/_authenticated/_system/_tenant/companies/index'
import { Route as AuthenticatedSystemTenantBuslinesIndexRouteImport } from './routes/_authenticated/_system/_tenant/buslines/index'
import { Route as AuthenticatedSystemTenantActingsIndexRouteImport } from './routes/_authenticated/_system/_tenant/actings/index'
import { Route as AuthenticatedSystemCompanyNpsReportsIndexRouteImport } from './routes/_authenticated/_system/_company/nps-reports/index'
import { Route as AuthenticatedSystemCompanyMyDocumentRequestsIndexRouteImport } from './routes/_authenticated/_system/_company/my-document-requests/index'
import { Route as AuthenticatedSystemCompanyCompanyIndexRouteImport } from './routes/_authenticated/_system/_company/company/index'
import { Route as AuthenticatedBackofficeCustomersCustomerIdMembersRouteImport } from './routes/_authenticated/backoffice/customers/$customerId/members'
import { Route as AuthenticatedBackofficeCustomersCustomerIdGeneralRouteImport } from './routes/_authenticated/backoffice/customers/$customerId/general'
import { Route as AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRouteImport } from './routes/_authenticated/_system/_tenant/document-requests/$documentRequestId'
import { Route as AuthenticatedSystemTenantBuslinesImportsRouteImport } from './routes/_authenticated/_system/_tenant/buslines/imports'
import { Route as AuthenticatedSystemCompanyMyDocumentRequestsNewRouteImport } from './routes/_authenticated/_system/_company/my-document-requests/new'
import { Route as AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRouteImport } from './routes/_authenticated/_system/_company/my-document-requests/$documentRequestId'
import { Route as AuthenticatedSystemCompanyCompanyUsersRouteImport } from './routes/_authenticated/_system/_company/company/users'
import { Route as AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteImport } from './routes/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/route'
import { Route as AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteImport } from './routes/_authenticated/_system/_tenant/companies/$companyId/route'
import { Route as AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteImport } from './routes/_authenticated/_system/_tenant/buslines/$buslineId/route'
import { Route as AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRouteImport } from './routes/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/index'
import { Route as AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRouteImport } from './routes/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/index'
import { Route as AuthenticatedSystemTenantSettingsRolesIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/roles/index'
import { Route as AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/gps-integrations/index'
import { Route as AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/document-categories/index'
import { Route as AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/company-departments/index'
import { Route as AuthenticatedSystemTenantCompaniesCompanyIdIndexRouteImport } from './routes/_authenticated/_system/_tenant/companies/$companyId/index'
import { Route as AuthenticatedSystemTenantBuslinesBuslineIdIndexRouteImport } from './routes/_authenticated/_system/_tenant/buslines/$buslineId/index'
import { Route as AuthenticatedSystemTenantActingsActingIdIndexRouteImport } from './routes/_authenticated/_system/_tenant/actings/$actingId/index'
import { Route as AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRouteImport } from './routes/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions'
import { Route as AuthenticatedSystemTenantSettingsRolesNewRouteImport } from './routes/_authenticated/_system/_tenant/settings/roles/new'
import { Route as AuthenticatedSystemTenantSettingsRolesRoleIdRouteImport } from './routes/_authenticated/_system/_tenant/settings/roles/$roleId'
import { Route as AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRouteImport } from './routes/_authenticated/_system/_tenant/settings/company-departments/new'
import { Route as AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRouteImport } from './routes/_authenticated/_system/_tenant/settings/company-departments/$departmentId'
import { Route as AuthenticatedSystemTenantCompaniesCompanyIdUsersRouteImport } from './routes/_authenticated/_system/_tenant/companies/$companyId/users'
import { Route as AuthenticatedSystemTenantSettingsHangTagCheckListIndexRouteImport } from './routes/_authenticated/_system/_tenant/settings/hang-tag/check-list/index'
import { Route as AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRouteImport } from './routes/_authenticated/_system/_tenant/buslines/$buslineId/acting/index'
import { Route as AuthenticatedSystemTenantSettingsHangTagCheckListNewRouteImport } from './routes/_authenticated/_system/_tenant/settings/hang-tag/check-list/new'
import { Route as AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRouteImport } from './routes/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId'

const AuthResetEmailIndexLazyRouteImport =
  createFileRoute('/auth/reset/email/')()

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticasGetsempliceMotoristaRoute =
  PoliticasGetsempliceMotoristaRouteImport.update({
    id: '/politicas/getsemplice-motorista',
    path: '/politicas/getsemplice-motorista',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsPublicIdRoute = DocsPublicIdRouteImport.update({
  id: '/docs/$publicId',
  path: '/docs/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBackofficeRouteRoute =
  AuthenticatedBackofficeRouteRouteImport.update({
    id: '/backoffice',
    path: '/backoffice',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSystemRouteRoute =
  AuthenticatedSystemRouteRouteImport.update({
    id: '/_system',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthSigninIndexRoute = AuthSigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/signin/index.lazy').then((d) => d.Route),
)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBackofficeIndexRoute =
  AuthenticatedBackofficeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBackofficeRouteRoute,
  } as any)
const AuthenticatedSystemIndexRoute =
  AuthenticatedSystemIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedSystemTenantRouteRoute =
  AuthenticatedSystemTenantRouteRouteImport.update({
    id: '/_tenant',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedSystemCompanyRouteRoute =
  AuthenticatedSystemCompanyRouteRouteImport.update({
    id: '/_company',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthResetEmailIndexLazyRoute = AuthResetEmailIndexLazyRouteImport.update({
  id: '/reset/email/',
  path: '/reset/email/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/reset/email/index.lazy').then((d) => d.Route),
)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset/password/',
  path: '/reset/password/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/auth/reset/password/index.lazy').then((d) => d.Route),
)
const AuthenticatedBackofficeCustomersIndexRoute =
  AuthenticatedBackofficeCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedBackofficeRouteRoute,
  } as any)
const AuthenticatedSystemProfileIndexRoute =
  AuthenticatedSystemProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedSystemDocumentsIndexRoute =
  AuthenticatedSystemDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedSystemBuslineSchedulesIndexRoute =
  AuthenticatedSystemBuslineSchedulesIndexRouteImport.update({
    id: '/busline-schedules/',
    path: '/busline-schedules/',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedDocsDocumentRequestDocumentRequestIdRoute =
  AuthenticatedDocsDocumentRequestDocumentRequestIdRouteImport.update({
    id: '/docs/document-request/$documentRequestId',
    path: '/docs/document-request/$documentRequestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute =
  AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRouteImport.update({
    id: '/busline-schedules/$buslineScheduleId',
    path: '/busline-schedules/$buslineScheduleId',
    getParentRoute: () => AuthenticatedSystemRouteRoute,
  } as any)
const AuthenticatedBackofficeCustomersCustomerIdRouteRoute =
  AuthenticatedBackofficeCustomersCustomerIdRouteRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedBackofficeRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsRouteRoute =
  AuthenticatedSystemTenantSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemCompanyCompanyRouteRoute =
  AuthenticatedSystemCompanyCompanyRouteRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedSystemCompanyRouteRoute,
  } as any)
const AuthenticatedBackofficeCustomersCustomerIdIndexRoute =
  AuthenticatedBackofficeCustomersCustomerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBackofficeCustomersCustomerIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsIndexRoute =
  AuthenticatedSystemTenantSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantNpsIndexRoute =
  AuthenticatedSystemTenantNpsIndexRouteImport.update({
    id: '/nps/',
    path: '/nps/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantFleetsIndexRoute =
  AuthenticatedSystemTenantFleetsIndexRouteImport.update({
    id: '/fleets/',
    path: '/fleets/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantDocumentRequestsIndexRoute =
  AuthenticatedSystemTenantDocumentRequestsIndexRouteImport.update({
    id: '/document-requests/',
    path: '/document-requests/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantCompaniesIndexRoute =
  AuthenticatedSystemTenantCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantBuslinesIndexRoute =
  AuthenticatedSystemTenantBuslinesIndexRouteImport.update({
    id: '/buslines/',
    path: '/buslines/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantActingsIndexRoute =
  AuthenticatedSystemTenantActingsIndexRouteImport.update({
    id: '/actings/',
    path: '/actings/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemCompanyNpsReportsIndexRoute =
  AuthenticatedSystemCompanyNpsReportsIndexRouteImport.update({
    id: '/nps-reports/',
    path: '/nps-reports/',
    getParentRoute: () => AuthenticatedSystemCompanyRouteRoute,
  } as any)
const AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute =
  AuthenticatedSystemCompanyMyDocumentRequestsIndexRouteImport.update({
    id: '/my-document-requests/',
    path: '/my-document-requests/',
    getParentRoute: () => AuthenticatedSystemCompanyRouteRoute,
  } as any)
const AuthenticatedSystemCompanyCompanyIndexRoute =
  AuthenticatedSystemCompanyCompanyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemCompanyCompanyRouteRoute,
  } as any)
const AuthenticatedBackofficeCustomersCustomerIdMembersRoute =
  AuthenticatedBackofficeCustomersCustomerIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedBackofficeCustomersCustomerIdRouteRoute,
  } as any)
const AuthenticatedBackofficeCustomersCustomerIdGeneralRoute =
  AuthenticatedBackofficeCustomersCustomerIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedBackofficeCustomersCustomerIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute =
  AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRouteImport.update({
    id: '/document-requests/$documentRequestId',
    path: '/document-requests/$documentRequestId',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantBuslinesImportsRoute =
  AuthenticatedSystemTenantBuslinesImportsRouteImport.update({
    id: '/buslines/imports',
    path: '/buslines/imports',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemCompanyMyDocumentRequestsNewRoute =
  AuthenticatedSystemCompanyMyDocumentRequestsNewRouteImport.update({
    id: '/my-document-requests/new',
    path: '/my-document-requests/new',
    getParentRoute: () => AuthenticatedSystemCompanyRouteRoute,
  } as any)
const AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute =
  AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRouteImport.update(
    {
      id: '/my-document-requests/$documentRequestId',
      path: '/my-document-requests/$documentRequestId',
      getParentRoute: () => AuthenticatedSystemCompanyRouteRoute,
    } as any,
  )
const AuthenticatedSystemCompanyCompanyUsersRoute =
  AuthenticatedSystemCompanyCompanyUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSystemCompanyCompanyRouteRoute,
  } as any)
const AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute =
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteImport.update(
    {
      id: '/documents/$companyDocumentPublicId/_documentOverview',
      path: '/documents/$companyDocumentPublicId',
      getParentRoute: () => AuthenticatedSystemRouteRoute,
    } as any,
  )
const AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute =
  AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute =
  AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteImport.update({
    id: '/buslines/$buslineId',
    path: '/buslines/$buslineId',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute =
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRouteImport.update(
    {
      id: '/documents/$companyDocumentPublicId/request-changes/',
      path: '/documents/$companyDocumentPublicId/request-changes/',
      getParentRoute: () => AuthenticatedSystemRouteRoute,
    } as any,
  )
const AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute =
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute,
    } as any,
  )
const AuthenticatedSystemTenantSettingsRolesIndexRoute =
  AuthenticatedSystemTenantSettingsRolesIndexRouteImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute =
  AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRouteImport.update({
    id: '/gps-integrations/',
    path: '/gps-integrations/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute =
  AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRouteImport.update({
    id: '/document-categories/',
    path: '/document-categories/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute =
  AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRouteImport.update({
    id: '/company-departments/',
    path: '/company-departments/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute =
  AuthenticatedSystemTenantCompaniesCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute =
  AuthenticatedSystemTenantBuslinesBuslineIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantActingsActingIdIndexRoute =
  AuthenticatedSystemTenantActingsActingIdIndexRouteImport.update({
    id: '/actings/$actingId/',
    path: '/actings/$actingId/',
    getParentRoute: () => AuthenticatedSystemTenantRouteRoute,
  } as any)
const AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute =
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRouteImport.update(
    {
      id: '/permissions',
      path: '/permissions',
      getParentRoute: () =>
        AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute,
    } as any,
  )
const AuthenticatedSystemTenantSettingsRolesNewRoute =
  AuthenticatedSystemTenantSettingsRolesNewRouteImport.update({
    id: '/roles/new',
    path: '/roles/new',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsRolesRoleIdRoute =
  AuthenticatedSystemTenantSettingsRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute =
  AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRouteImport.update({
    id: '/company-departments/new',
    path: '/company-departments/new',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute =
  AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRouteImport.update(
    {
      id: '/company-departments/$departmentId',
      path: '/company-departments/$departmentId',
      getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
    } as any,
  )
const AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute =
  AuthenticatedSystemTenantCompaniesCompanyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute =
  AuthenticatedSystemTenantSettingsHangTagCheckListIndexRouteImport.update({
    id: '/hang-tag/check-list/',
    path: '/hang-tag/check-list/',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute =
  AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRouteImport.update({
    id: '/acting/',
    path: '/acting/',
    getParentRoute: () => AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute =
  AuthenticatedSystemTenantSettingsHangTagCheckListNewRouteImport.update({
    id: '/hang-tag/check-list/new',
    path: '/hang-tag/check-list/new',
    getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
  } as any)
const AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute =
  AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRouteImport.update(
    {
      id: '/hang-tag/check-list/$checklistId',
      path: '/hang-tag/check-list/$checklistId',
      getParentRoute: () => AuthenticatedSystemTenantSettingsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/': typeof AuthenticatedSystemIndexRoute
  '/backoffice': typeof AuthenticatedBackofficeRouteRouteWithChildren
  '/docs/$publicId': typeof DocsPublicIdRoute
  '/politicas/getsemplice-motorista': typeof PoliticasGetsempliceMotoristaRoute
  '/backoffice/': typeof AuthenticatedBackofficeIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/auth/signin/': typeof AuthSigninIndexRoute
  '/company': typeof AuthenticatedSystemCompanyCompanyRouteRouteWithChildren
  '/settings': typeof AuthenticatedSystemTenantSettingsRouteRouteWithChildren
  '/backoffice/customers/$customerId': typeof AuthenticatedBackofficeCustomersCustomerIdRouteRouteWithChildren
  '/busline-schedules/$buslineScheduleId': typeof AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute
  '/docs/document-request/$documentRequestId': typeof AuthenticatedDocsDocumentRequestDocumentRequestIdRoute
  '/busline-schedules/': typeof AuthenticatedSystemBuslineSchedulesIndexRoute
  '/documents/': typeof AuthenticatedSystemDocumentsIndexRoute
  '/profile/': typeof AuthenticatedSystemProfileIndexRoute
  '/backoffice/customers/': typeof AuthenticatedBackofficeCustomersIndexRoute
  '/auth/reset/password/': typeof AuthResetPasswordIndexRoute
  '/auth/reset/email/': typeof AuthResetEmailIndexLazyRoute
  '/buslines/$buslineId': typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteWithChildren
  '/companies/$companyId': typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteWithChildren
  '/documents/$companyDocumentPublicId': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteWithChildren
  '/company/users': typeof AuthenticatedSystemCompanyCompanyUsersRoute
  '/my-document-requests/$documentRequestId': typeof AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute
  '/my-document-requests/new': typeof AuthenticatedSystemCompanyMyDocumentRequestsNewRoute
  '/buslines/imports': typeof AuthenticatedSystemTenantBuslinesImportsRoute
  '/document-requests/$documentRequestId': typeof AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute
  '/backoffice/customers/$customerId/general': typeof AuthenticatedBackofficeCustomersCustomerIdGeneralRoute
  '/backoffice/customers/$customerId/members': typeof AuthenticatedBackofficeCustomersCustomerIdMembersRoute
  '/company/': typeof AuthenticatedSystemCompanyCompanyIndexRoute
  '/my-document-requests/': typeof AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute
  '/nps-reports/': typeof AuthenticatedSystemCompanyNpsReportsIndexRoute
  '/actings/': typeof AuthenticatedSystemTenantActingsIndexRoute
  '/buslines/': typeof AuthenticatedSystemTenantBuslinesIndexRoute
  '/companies/': typeof AuthenticatedSystemTenantCompaniesIndexRoute
  '/document-requests/': typeof AuthenticatedSystemTenantDocumentRequestsIndexRoute
  '/fleets/': typeof AuthenticatedSystemTenantFleetsIndexRoute
  '/nps/': typeof AuthenticatedSystemTenantNpsIndexRoute
  '/settings/': typeof AuthenticatedSystemTenantSettingsIndexRoute
  '/backoffice/customers/$customerId/': typeof AuthenticatedBackofficeCustomersCustomerIdIndexRoute
  '/companies/$companyId/users': typeof AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute
  '/settings/company-departments/$departmentId': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute
  '/settings/company-departments/new': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute
  '/settings/roles/$roleId': typeof AuthenticatedSystemTenantSettingsRolesRoleIdRoute
  '/settings/roles/new': typeof AuthenticatedSystemTenantSettingsRolesNewRoute
  '/documents/$companyDocumentPublicId/permissions': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute
  '/actings/$actingId/': typeof AuthenticatedSystemTenantActingsActingIdIndexRoute
  '/buslines/$buslineId/': typeof AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute
  '/companies/$companyId/': typeof AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute
  '/settings/company-departments/': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute
  '/settings/document-categories/': typeof AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute
  '/settings/gps-integrations/': typeof AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute
  '/settings/roles/': typeof AuthenticatedSystemTenantSettingsRolesIndexRoute
  '/documents/$companyDocumentPublicId/': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute
  '/documents/$companyDocumentPublicId/request-changes/': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute
  '/settings/hang-tag/check-list/$checklistId': typeof AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute
  '/settings/hang-tag/check-list/new': typeof AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute
  '/buslines/$buslineId/acting/': typeof AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute
  '/settings/hang-tag/check-list/': typeof AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/': typeof AuthenticatedSystemIndexRoute
  '/docs/$publicId': typeof DocsPublicIdRoute
  '/politicas/getsemplice-motorista': typeof PoliticasGetsempliceMotoristaRoute
  '/backoffice': typeof AuthenticatedBackofficeIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/auth/signin': typeof AuthSigninIndexRoute
  '/busline-schedules/$buslineScheduleId': typeof AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute
  '/docs/document-request/$documentRequestId': typeof AuthenticatedDocsDocumentRequestDocumentRequestIdRoute
  '/busline-schedules': typeof AuthenticatedSystemBuslineSchedulesIndexRoute
  '/documents': typeof AuthenticatedSystemDocumentsIndexRoute
  '/profile': typeof AuthenticatedSystemProfileIndexRoute
  '/backoffice/customers': typeof AuthenticatedBackofficeCustomersIndexRoute
  '/auth/reset/password': typeof AuthResetPasswordIndexRoute
  '/auth/reset/email': typeof AuthResetEmailIndexLazyRoute
  '/company/users': typeof AuthenticatedSystemCompanyCompanyUsersRoute
  '/my-document-requests/$documentRequestId': typeof AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute
  '/my-document-requests/new': typeof AuthenticatedSystemCompanyMyDocumentRequestsNewRoute
  '/buslines/imports': typeof AuthenticatedSystemTenantBuslinesImportsRoute
  '/document-requests/$documentRequestId': typeof AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute
  '/backoffice/customers/$customerId/general': typeof AuthenticatedBackofficeCustomersCustomerIdGeneralRoute
  '/backoffice/customers/$customerId/members': typeof AuthenticatedBackofficeCustomersCustomerIdMembersRoute
  '/company': typeof AuthenticatedSystemCompanyCompanyIndexRoute
  '/my-document-requests': typeof AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute
  '/nps-reports': typeof AuthenticatedSystemCompanyNpsReportsIndexRoute
  '/actings': typeof AuthenticatedSystemTenantActingsIndexRoute
  '/buslines': typeof AuthenticatedSystemTenantBuslinesIndexRoute
  '/companies': typeof AuthenticatedSystemTenantCompaniesIndexRoute
  '/document-requests': typeof AuthenticatedSystemTenantDocumentRequestsIndexRoute
  '/fleets': typeof AuthenticatedSystemTenantFleetsIndexRoute
  '/nps': typeof AuthenticatedSystemTenantNpsIndexRoute
  '/settings': typeof AuthenticatedSystemTenantSettingsIndexRoute
  '/backoffice/customers/$customerId': typeof AuthenticatedBackofficeCustomersCustomerIdIndexRoute
  '/companies/$companyId/users': typeof AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute
  '/settings/company-departments/$departmentId': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute
  '/settings/company-departments/new': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute
  '/settings/roles/$roleId': typeof AuthenticatedSystemTenantSettingsRolesRoleIdRoute
  '/settings/roles/new': typeof AuthenticatedSystemTenantSettingsRolesNewRoute
  '/documents/$companyDocumentPublicId/permissions': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute
  '/actings/$actingId': typeof AuthenticatedSystemTenantActingsActingIdIndexRoute
  '/buslines/$buslineId': typeof AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute
  '/companies/$companyId': typeof AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute
  '/settings/company-departments': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute
  '/settings/document-categories': typeof AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute
  '/settings/gps-integrations': typeof AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute
  '/settings/roles': typeof AuthenticatedSystemTenantSettingsRolesIndexRoute
  '/documents/$companyDocumentPublicId': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute
  '/documents/$companyDocumentPublicId/request-changes': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute
  '/settings/hang-tag/check-list/$checklistId': typeof AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute
  '/settings/hang-tag/check-list/new': typeof AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute
  '/buslines/$buslineId/acting': typeof AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute
  '/settings/hang-tag/check-list': typeof AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/_system': typeof AuthenticatedSystemRouteRouteWithChildren
  '/_authenticated/backoffice': typeof AuthenticatedBackofficeRouteRouteWithChildren
  '/docs/$publicId': typeof DocsPublicIdRoute
  '/politicas/getsemplice-motorista': typeof PoliticasGetsempliceMotoristaRoute
  '/_authenticated/_system/_company': typeof AuthenticatedSystemCompanyRouteRouteWithChildren
  '/_authenticated/_system/_tenant': typeof AuthenticatedSystemTenantRouteRouteWithChildren
  '/_authenticated/_system/': typeof AuthenticatedSystemIndexRoute
  '/_authenticated/backoffice/': typeof AuthenticatedBackofficeIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/auth/signin/': typeof AuthSigninIndexRoute
  '/_authenticated/_system/_company/company': typeof AuthenticatedSystemCompanyCompanyRouteRouteWithChildren
  '/_authenticated/_system/_tenant/settings': typeof AuthenticatedSystemTenantSettingsRouteRouteWithChildren
  '/_authenticated/backoffice/customers/$customerId': typeof AuthenticatedBackofficeCustomersCustomerIdRouteRouteWithChildren
  '/_authenticated/_system/busline-schedules/$buslineScheduleId': typeof AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute
  '/_authenticated/docs/document-request/$documentRequestId': typeof AuthenticatedDocsDocumentRequestDocumentRequestIdRoute
  '/_authenticated/_system/busline-schedules/': typeof AuthenticatedSystemBuslineSchedulesIndexRoute
  '/_authenticated/_system/documents/': typeof AuthenticatedSystemDocumentsIndexRoute
  '/_authenticated/_system/profile/': typeof AuthenticatedSystemProfileIndexRoute
  '/_authenticated/backoffice/customers/': typeof AuthenticatedBackofficeCustomersIndexRoute
  '/auth/reset/password/': typeof AuthResetPasswordIndexRoute
  '/auth/reset/email/': typeof AuthResetEmailIndexLazyRoute
  '/_authenticated/_system/_tenant/buslines/$buslineId': typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteWithChildren
  '/_authenticated/_system/_tenant/companies/$companyId': typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteWithChildren
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteWithChildren
  '/_authenticated/_system/_company/company/users': typeof AuthenticatedSystemCompanyCompanyUsersRoute
  '/_authenticated/_system/_company/my-document-requests/$documentRequestId': typeof AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute
  '/_authenticated/_system/_company/my-document-requests/new': typeof AuthenticatedSystemCompanyMyDocumentRequestsNewRoute
  '/_authenticated/_system/_tenant/buslines/imports': typeof AuthenticatedSystemTenantBuslinesImportsRoute
  '/_authenticated/_system/_tenant/document-requests/$documentRequestId': typeof AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute
  '/_authenticated/backoffice/customers/$customerId/general': typeof AuthenticatedBackofficeCustomersCustomerIdGeneralRoute
  '/_authenticated/backoffice/customers/$customerId/members': typeof AuthenticatedBackofficeCustomersCustomerIdMembersRoute
  '/_authenticated/_system/_company/company/': typeof AuthenticatedSystemCompanyCompanyIndexRoute
  '/_authenticated/_system/_company/my-document-requests/': typeof AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute
  '/_authenticated/_system/_company/nps-reports/': typeof AuthenticatedSystemCompanyNpsReportsIndexRoute
  '/_authenticated/_system/_tenant/actings/': typeof AuthenticatedSystemTenantActingsIndexRoute
  '/_authenticated/_system/_tenant/buslines/': typeof AuthenticatedSystemTenantBuslinesIndexRoute
  '/_authenticated/_system/_tenant/companies/': typeof AuthenticatedSystemTenantCompaniesIndexRoute
  '/_authenticated/_system/_tenant/document-requests/': typeof AuthenticatedSystemTenantDocumentRequestsIndexRoute
  '/_authenticated/_system/_tenant/fleets/': typeof AuthenticatedSystemTenantFleetsIndexRoute
  '/_authenticated/_system/_tenant/nps/': typeof AuthenticatedSystemTenantNpsIndexRoute
  '/_authenticated/_system/_tenant/settings/': typeof AuthenticatedSystemTenantSettingsIndexRoute
  '/_authenticated/backoffice/customers/$customerId/': typeof AuthenticatedBackofficeCustomersCustomerIdIndexRoute
  '/_authenticated/_system/_tenant/companies/$companyId/users': typeof AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute
  '/_authenticated/_system/_tenant/settings/company-departments/$departmentId': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute
  '/_authenticated/_system/_tenant/settings/company-departments/new': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute
  '/_authenticated/_system/_tenant/settings/roles/$roleId': typeof AuthenticatedSystemTenantSettingsRolesRoleIdRoute
  '/_authenticated/_system/_tenant/settings/roles/new': typeof AuthenticatedSystemTenantSettingsRolesNewRoute
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute
  '/_authenticated/_system/_tenant/actings/$actingId/': typeof AuthenticatedSystemTenantActingsActingIdIndexRoute
  '/_authenticated/_system/_tenant/buslines/$buslineId/': typeof AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute
  '/_authenticated/_system/_tenant/companies/$companyId/': typeof AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute
  '/_authenticated/_system/_tenant/settings/company-departments/': typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute
  '/_authenticated/_system/_tenant/settings/document-categories/': typeof AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute
  '/_authenticated/_system/_tenant/settings/gps-integrations/': typeof AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute
  '/_authenticated/_system/_tenant/settings/roles/': typeof AuthenticatedSystemTenantSettingsRolesIndexRoute
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute
  '/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/': typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId': typeof AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/new': typeof AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute
  '/_authenticated/_system/_tenant/buslines/$buslineId/acting/': typeof AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/': typeof AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/'
    | '/backoffice'
    | '/docs/$publicId'
    | '/politicas/getsemplice-motorista'
    | '/backoffice/'
    | '/onboarding/'
    | '/auth/signin/'
    | '/company'
    | '/settings'
    | '/backoffice/customers/$customerId'
    | '/busline-schedules/$buslineScheduleId'
    | '/docs/document-request/$documentRequestId'
    | '/busline-schedules/'
    | '/documents/'
    | '/profile/'
    | '/backoffice/customers/'
    | '/auth/reset/password/'
    | '/auth/reset/email/'
    | '/buslines/$buslineId'
    | '/companies/$companyId'
    | '/documents/$companyDocumentPublicId'
    | '/company/users'
    | '/my-document-requests/$documentRequestId'
    | '/my-document-requests/new'
    | '/buslines/imports'
    | '/document-requests/$documentRequestId'
    | '/backoffice/customers/$customerId/general'
    | '/backoffice/customers/$customerId/members'
    | '/company/'
    | '/my-document-requests/'
    | '/nps-reports/'
    | '/actings/'
    | '/buslines/'
    | '/companies/'
    | '/document-requests/'
    | '/fleets/'
    | '/nps/'
    | '/settings/'
    | '/backoffice/customers/$customerId/'
    | '/companies/$companyId/users'
    | '/settings/company-departments/$departmentId'
    | '/settings/company-departments/new'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/documents/$companyDocumentPublicId/permissions'
    | '/actings/$actingId/'
    | '/buslines/$buslineId/'
    | '/companies/$companyId/'
    | '/settings/company-departments/'
    | '/settings/document-categories/'
    | '/settings/gps-integrations/'
    | '/settings/roles/'
    | '/documents/$companyDocumentPublicId/'
    | '/documents/$companyDocumentPublicId/request-changes/'
    | '/settings/hang-tag/check-list/$checklistId'
    | '/settings/hang-tag/check-list/new'
    | '/buslines/$buslineId/acting/'
    | '/settings/hang-tag/check-list/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/'
    | '/docs/$publicId'
    | '/politicas/getsemplice-motorista'
    | '/backoffice'
    | '/onboarding'
    | '/auth/signin'
    | '/busline-schedules/$buslineScheduleId'
    | '/docs/document-request/$documentRequestId'
    | '/busline-schedules'
    | '/documents'
    | '/profile'
    | '/backoffice/customers'
    | '/auth/reset/password'
    | '/auth/reset/email'
    | '/company/users'
    | '/my-document-requests/$documentRequestId'
    | '/my-document-requests/new'
    | '/buslines/imports'
    | '/document-requests/$documentRequestId'
    | '/backoffice/customers/$customerId/general'
    | '/backoffice/customers/$customerId/members'
    | '/company'
    | '/my-document-requests'
    | '/nps-reports'
    | '/actings'
    | '/buslines'
    | '/companies'
    | '/document-requests'
    | '/fleets'
    | '/nps'
    | '/settings'
    | '/backoffice/customers/$customerId'
    | '/companies/$companyId/users'
    | '/settings/company-departments/$departmentId'
    | '/settings/company-departments/new'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/documents/$companyDocumentPublicId/permissions'
    | '/actings/$actingId'
    | '/buslines/$buslineId'
    | '/companies/$companyId'
    | '/settings/company-departments'
    | '/settings/document-categories'
    | '/settings/gps-integrations'
    | '/settings/roles'
    | '/documents/$companyDocumentPublicId'
    | '/documents/$companyDocumentPublicId/request-changes'
    | '/settings/hang-tag/check-list/$checklistId'
    | '/settings/hang-tag/check-list/new'
    | '/buslines/$buslineId/acting'
    | '/settings/hang-tag/check-list'
  id:
    | '__root__'
    | '/auth'
    | '/_authenticated'
    | '/_authenticated/_system'
    | '/_authenticated/backoffice'
    | '/docs/$publicId'
    | '/politicas/getsemplice-motorista'
    | '/_authenticated/_system/_company'
    | '/_authenticated/_system/_tenant'
    | '/_authenticated/_system/'
    | '/_authenticated/backoffice/'
    | '/_authenticated/onboarding/'
    | '/auth/signin/'
    | '/_authenticated/_system/_company/company'
    | '/_authenticated/_system/_tenant/settings'
    | '/_authenticated/backoffice/customers/$customerId'
    | '/_authenticated/_system/busline-schedules/$buslineScheduleId'
    | '/_authenticated/docs/document-request/$documentRequestId'
    | '/_authenticated/_system/busline-schedules/'
    | '/_authenticated/_system/documents/'
    | '/_authenticated/_system/profile/'
    | '/_authenticated/backoffice/customers/'
    | '/auth/reset/password/'
    | '/auth/reset/email/'
    | '/_authenticated/_system/_tenant/buslines/$buslineId'
    | '/_authenticated/_system/_tenant/companies/$companyId'
    | '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview'
    | '/_authenticated/_system/_company/company/users'
    | '/_authenticated/_system/_company/my-document-requests/$documentRequestId'
    | '/_authenticated/_system/_company/my-document-requests/new'
    | '/_authenticated/_system/_tenant/buslines/imports'
    | '/_authenticated/_system/_tenant/document-requests/$documentRequestId'
    | '/_authenticated/backoffice/customers/$customerId/general'
    | '/_authenticated/backoffice/customers/$customerId/members'
    | '/_authenticated/_system/_company/company/'
    | '/_authenticated/_system/_company/my-document-requests/'
    | '/_authenticated/_system/_company/nps-reports/'
    | '/_authenticated/_system/_tenant/actings/'
    | '/_authenticated/_system/_tenant/buslines/'
    | '/_authenticated/_system/_tenant/companies/'
    | '/_authenticated/_system/_tenant/document-requests/'
    | '/_authenticated/_system/_tenant/fleets/'
    | '/_authenticated/_system/_tenant/nps/'
    | '/_authenticated/_system/_tenant/settings/'
    | '/_authenticated/backoffice/customers/$customerId/'
    | '/_authenticated/_system/_tenant/companies/$companyId/users'
    | '/_authenticated/_system/_tenant/settings/company-departments/$departmentId'
    | '/_authenticated/_system/_tenant/settings/company-departments/new'
    | '/_authenticated/_system/_tenant/settings/roles/$roleId'
    | '/_authenticated/_system/_tenant/settings/roles/new'
    | '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions'
    | '/_authenticated/_system/_tenant/actings/$actingId/'
    | '/_authenticated/_system/_tenant/buslines/$buslineId/'
    | '/_authenticated/_system/_tenant/companies/$companyId/'
    | '/_authenticated/_system/_tenant/settings/company-departments/'
    | '/_authenticated/_system/_tenant/settings/document-categories/'
    | '/_authenticated/_system/_tenant/settings/gps-integrations/'
    | '/_authenticated/_system/_tenant/settings/roles/'
    | '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/'
    | '/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/'
    | '/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId'
    | '/_authenticated/_system/_tenant/settings/hang-tag/check-list/new'
    | '/_authenticated/_system/_tenant/buslines/$buslineId/acting/'
    | '/_authenticated/_system/_tenant/settings/hang-tag/check-list/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  DocsPublicIdRoute: typeof DocsPublicIdRoute
  PoliticasGetsempliceMotoristaRoute: typeof PoliticasGetsempliceMotoristaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politicas/getsemplice-motorista': {
      id: '/politicas/getsemplice-motorista'
      path: '/politicas/getsemplice-motorista'
      fullPath: '/politicas/getsemplice-motorista'
      preLoaderRoute: typeof PoliticasGetsempliceMotoristaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/$publicId': {
      id: '/docs/$publicId'
      path: '/docs/$publicId'
      fullPath: '/docs/$publicId'
      preLoaderRoute: typeof DocsPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/backoffice': {
      id: '/_authenticated/backoffice'
      path: '/backoffice'
      fullPath: '/backoffice'
      preLoaderRoute: typeof AuthenticatedBackofficeRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_system': {
      id: '/_authenticated/_system'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSystemRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/signin/': {
      id: '/auth/signin/'
      path: '/signin'
      fullPath: '/auth/signin/'
      preLoaderRoute: typeof AuthSigninIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/backoffice/': {
      id: '/_authenticated/backoffice/'
      path: '/'
      fullPath: '/backoffice/'
      preLoaderRoute: typeof AuthenticatedBackofficeIndexRouteImport
      parentRoute: typeof AuthenticatedBackofficeRouteRoute
    }
    '/_authenticated/_system/': {
      id: '/_authenticated/_system/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSystemIndexRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/_tenant': {
      id: '/_authenticated/_system/_tenant'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSystemTenantRouteRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/_company': {
      id: '/_authenticated/_system/_company'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSystemCompanyRouteRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/auth/reset/email/': {
      id: '/auth/reset/email/'
      path: '/reset/email'
      fullPath: '/auth/reset/email/'
      preLoaderRoute: typeof AuthResetEmailIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset/password/': {
      id: '/auth/reset/password/'
      path: '/reset/password'
      fullPath: '/auth/reset/password/'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/backoffice/customers/': {
      id: '/_authenticated/backoffice/customers/'
      path: '/customers'
      fullPath: '/backoffice/customers/'
      preLoaderRoute: typeof AuthenticatedBackofficeCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedBackofficeRouteRoute
    }
    '/_authenticated/_system/profile/': {
      id: '/_authenticated/_system/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedSystemProfileIndexRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/documents/': {
      id: '/_authenticated/_system/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedSystemDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/busline-schedules/': {
      id: '/_authenticated/_system/busline-schedules/'
      path: '/busline-schedules'
      fullPath: '/busline-schedules/'
      preLoaderRoute: typeof AuthenticatedSystemBuslineSchedulesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/docs/document-request/$documentRequestId': {
      id: '/_authenticated/docs/document-request/$documentRequestId'
      path: '/docs/document-request/$documentRequestId'
      fullPath: '/docs/document-request/$documentRequestId'
      preLoaderRoute: typeof AuthenticatedDocsDocumentRequestDocumentRequestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_system/busline-schedules/$buslineScheduleId': {
      id: '/_authenticated/_system/busline-schedules/$buslineScheduleId'
      path: '/busline-schedules/$buslineScheduleId'
      fullPath: '/busline-schedules/$buslineScheduleId'
      preLoaderRoute: typeof AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/backoffice/customers/$customerId': {
      id: '/_authenticated/backoffice/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/backoffice/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedBackofficeCustomersCustomerIdRouteRouteImport
      parentRoute: typeof AuthenticatedBackofficeRouteRoute
    }
    '/_authenticated/_system/_tenant/settings': {
      id: '/_authenticated/_system/_tenant/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_company/company': {
      id: '/_authenticated/_system/_company/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AuthenticatedSystemCompanyCompanyRouteRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyRouteRoute
    }
    '/_authenticated/backoffice/customers/$customerId/': {
      id: '/_authenticated/backoffice/customers/$customerId/'
      path: '/'
      fullPath: '/backoffice/customers/$customerId/'
      preLoaderRoute: typeof AuthenticatedBackofficeCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedBackofficeCustomersCustomerIdRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/': {
      id: '/_authenticated/_system/_tenant/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/nps/': {
      id: '/_authenticated/_system/_tenant/nps/'
      path: '/nps'
      fullPath: '/nps/'
      preLoaderRoute: typeof AuthenticatedSystemTenantNpsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/fleets/': {
      id: '/_authenticated/_system/_tenant/fleets/'
      path: '/fleets'
      fullPath: '/fleets/'
      preLoaderRoute: typeof AuthenticatedSystemTenantFleetsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/document-requests/': {
      id: '/_authenticated/_system/_tenant/document-requests/'
      path: '/document-requests'
      fullPath: '/document-requests/'
      preLoaderRoute: typeof AuthenticatedSystemTenantDocumentRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/companies/': {
      id: '/_authenticated/_system/_tenant/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedSystemTenantCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/buslines/': {
      id: '/_authenticated/_system/_tenant/buslines/'
      path: '/buslines'
      fullPath: '/buslines/'
      preLoaderRoute: typeof AuthenticatedSystemTenantBuslinesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/actings/': {
      id: '/_authenticated/_system/_tenant/actings/'
      path: '/actings'
      fullPath: '/actings/'
      preLoaderRoute: typeof AuthenticatedSystemTenantActingsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_company/nps-reports/': {
      id: '/_authenticated/_system/_company/nps-reports/'
      path: '/nps-reports'
      fullPath: '/nps-reports/'
      preLoaderRoute: typeof AuthenticatedSystemCompanyNpsReportsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyRouteRoute
    }
    '/_authenticated/_system/_company/my-document-requests/': {
      id: '/_authenticated/_system/_company/my-document-requests/'
      path: '/my-document-requests'
      fullPath: '/my-document-requests/'
      preLoaderRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyRouteRoute
    }
    '/_authenticated/_system/_company/company/': {
      id: '/_authenticated/_system/_company/company/'
      path: '/'
      fullPath: '/company/'
      preLoaderRoute: typeof AuthenticatedSystemCompanyCompanyIndexRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyCompanyRouteRoute
    }
    '/_authenticated/backoffice/customers/$customerId/members': {
      id: '/_authenticated/backoffice/customers/$customerId/members'
      path: '/members'
      fullPath: '/backoffice/customers/$customerId/members'
      preLoaderRoute: typeof AuthenticatedBackofficeCustomersCustomerIdMembersRouteImport
      parentRoute: typeof AuthenticatedBackofficeCustomersCustomerIdRouteRoute
    }
    '/_authenticated/backoffice/customers/$customerId/general': {
      id: '/_authenticated/backoffice/customers/$customerId/general'
      path: '/general'
      fullPath: '/backoffice/customers/$customerId/general'
      preLoaderRoute: typeof AuthenticatedBackofficeCustomersCustomerIdGeneralRouteImport
      parentRoute: typeof AuthenticatedBackofficeCustomersCustomerIdRouteRoute
    }
    '/_authenticated/_system/_tenant/document-requests/$documentRequestId': {
      id: '/_authenticated/_system/_tenant/document-requests/$documentRequestId'
      path: '/document-requests/$documentRequestId'
      fullPath: '/document-requests/$documentRequestId'
      preLoaderRoute: typeof AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/buslines/imports': {
      id: '/_authenticated/_system/_tenant/buslines/imports'
      path: '/buslines/imports'
      fullPath: '/buslines/imports'
      preLoaderRoute: typeof AuthenticatedSystemTenantBuslinesImportsRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_company/my-document-requests/new': {
      id: '/_authenticated/_system/_company/my-document-requests/new'
      path: '/my-document-requests/new'
      fullPath: '/my-document-requests/new'
      preLoaderRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsNewRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyRouteRoute
    }
    '/_authenticated/_system/_company/my-document-requests/$documentRequestId': {
      id: '/_authenticated/_system/_company/my-document-requests/$documentRequestId'
      path: '/my-document-requests/$documentRequestId'
      fullPath: '/my-document-requests/$documentRequestId'
      preLoaderRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyRouteRoute
    }
    '/_authenticated/_system/_company/company/users': {
      id: '/_authenticated/_system/_company/company/users'
      path: '/users'
      fullPath: '/company/users'
      preLoaderRoute: typeof AuthenticatedSystemCompanyCompanyUsersRouteImport
      parentRoute: typeof AuthenticatedSystemCompanyCompanyRouteRoute
    }
    '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview': {
      id: '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview'
      path: '/documents/$companyDocumentPublicId'
      fullPath: '/documents/$companyDocumentPublicId'
      preLoaderRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/_tenant/companies/$companyId': {
      id: '/_authenticated/_system/_tenant/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/_tenant/buslines/$buslineId': {
      id: '/_authenticated/_system/_tenant/buslines/$buslineId'
      path: '/buslines/$buslineId'
      fullPath: '/buslines/$buslineId'
      preLoaderRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/': {
      id: '/_authenticated/_system/documents/$companyDocumentPublicId/request-changes/'
      path: '/documents/$companyDocumentPublicId/request-changes'
      fullPath: '/documents/$companyDocumentPublicId/request-changes/'
      preLoaderRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemRouteRoute
    }
    '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/': {
      id: '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/'
      path: '/'
      fullPath: '/documents/$companyDocumentPublicId/'
      preLoaderRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/roles/': {
      id: '/_authenticated/_system/_tenant/settings/roles/'
      path: '/roles'
      fullPath: '/settings/roles/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsRolesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/gps-integrations/': {
      id: '/_authenticated/_system/_tenant/settings/gps-integrations/'
      path: '/gps-integrations'
      fullPath: '/settings/gps-integrations/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/document-categories/': {
      id: '/_authenticated/_system/_tenant/settings/document-categories/'
      path: '/document-categories'
      fullPath: '/settings/document-categories/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/company-departments/': {
      id: '/_authenticated/_system/_tenant/settings/company-departments/'
      path: '/company-departments'
      fullPath: '/settings/company-departments/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/companies/$companyId/': {
      id: '/_authenticated/_system/_tenant/companies/$companyId/'
      path: '/'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/_system/_tenant/buslines/$buslineId/': {
      id: '/_authenticated/_system/_tenant/buslines/$buslineId/'
      path: '/'
      fullPath: '/buslines/$buslineId/'
      preLoaderRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute
    }
    '/_authenticated/_system/_tenant/actings/$actingId/': {
      id: '/_authenticated/_system/_tenant/actings/$actingId/'
      path: '/actings/$actingId'
      fullPath: '/actings/$actingId/'
      preLoaderRoute: typeof AuthenticatedSystemTenantActingsActingIdIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantRouteRoute
    }
    '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions': {
      id: '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions'
      path: '/permissions'
      fullPath: '/documents/$companyDocumentPublicId/permissions'
      preLoaderRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRouteImport
      parentRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/roles/new': {
      id: '/_authenticated/_system/_tenant/settings/roles/new'
      path: '/roles/new'
      fullPath: '/settings/roles/new'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsRolesNewRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/roles/$roleId': {
      id: '/_authenticated/_system/_tenant/settings/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/settings/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/company-departments/new': {
      id: '/_authenticated/_system/_tenant/settings/company-departments/new'
      path: '/company-departments/new'
      fullPath: '/settings/company-departments/new'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/company-departments/$departmentId': {
      id: '/_authenticated/_system/_tenant/settings/company-departments/$departmentId'
      path: '/company-departments/$departmentId'
      fullPath: '/settings/company-departments/$departmentId'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/companies/$companyId/users': {
      id: '/_authenticated/_system/_tenant/companies/$companyId/users'
      path: '/users'
      fullPath: '/companies/$companyId/users'
      preLoaderRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdUsersRouteImport
      parentRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/hang-tag/check-list/': {
      id: '/_authenticated/_system/_tenant/settings/hang-tag/check-list/'
      path: '/hang-tag/check-list'
      fullPath: '/settings/hang-tag/check-list/'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/buslines/$buslineId/acting/': {
      id: '/_authenticated/_system/_tenant/buslines/$buslineId/acting/'
      path: '/acting'
      fullPath: '/buslines/$buslineId/acting/'
      preLoaderRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRouteImport
      parentRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/hang-tag/check-list/new': {
      id: '/_authenticated/_system/_tenant/settings/hang-tag/check-list/new'
      path: '/hang-tag/check-list/new'
      fullPath: '/settings/hang-tag/check-list/new'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListNewRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
    '/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId': {
      id: '/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId'
      path: '/hang-tag/check-list/$checklistId'
      fullPath: '/settings/hang-tag/check-list/$checklistId'
      preLoaderRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRouteImport
      parentRoute: typeof AuthenticatedSystemTenantSettingsRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthSigninIndexRoute: typeof AuthSigninIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthResetEmailIndexLazyRoute: typeof AuthResetEmailIndexLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthSigninIndexRoute: AuthSigninIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthResetEmailIndexLazyRoute: AuthResetEmailIndexLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedSystemCompanyCompanyRouteRouteChildren {
  AuthenticatedSystemCompanyCompanyUsersRoute: typeof AuthenticatedSystemCompanyCompanyUsersRoute
  AuthenticatedSystemCompanyCompanyIndexRoute: typeof AuthenticatedSystemCompanyCompanyIndexRoute
}

const AuthenticatedSystemCompanyCompanyRouteRouteChildren: AuthenticatedSystemCompanyCompanyRouteRouteChildren =
  {
    AuthenticatedSystemCompanyCompanyUsersRoute:
      AuthenticatedSystemCompanyCompanyUsersRoute,
    AuthenticatedSystemCompanyCompanyIndexRoute:
      AuthenticatedSystemCompanyCompanyIndexRoute,
  }

const AuthenticatedSystemCompanyCompanyRouteRouteWithChildren =
  AuthenticatedSystemCompanyCompanyRouteRoute._addFileChildren(
    AuthenticatedSystemCompanyCompanyRouteRouteChildren,
  )

interface AuthenticatedSystemCompanyRouteRouteChildren {
  AuthenticatedSystemCompanyCompanyRouteRoute: typeof AuthenticatedSystemCompanyCompanyRouteRouteWithChildren
  AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute
  AuthenticatedSystemCompanyMyDocumentRequestsNewRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsNewRoute
  AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute: typeof AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute
  AuthenticatedSystemCompanyNpsReportsIndexRoute: typeof AuthenticatedSystemCompanyNpsReportsIndexRoute
}

const AuthenticatedSystemCompanyRouteRouteChildren: AuthenticatedSystemCompanyRouteRouteChildren =
  {
    AuthenticatedSystemCompanyCompanyRouteRoute:
      AuthenticatedSystemCompanyCompanyRouteRouteWithChildren,
    AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute:
      AuthenticatedSystemCompanyMyDocumentRequestsDocumentRequestIdRoute,
    AuthenticatedSystemCompanyMyDocumentRequestsNewRoute:
      AuthenticatedSystemCompanyMyDocumentRequestsNewRoute,
    AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute:
      AuthenticatedSystemCompanyMyDocumentRequestsIndexRoute,
    AuthenticatedSystemCompanyNpsReportsIndexRoute:
      AuthenticatedSystemCompanyNpsReportsIndexRoute,
  }

const AuthenticatedSystemCompanyRouteRouteWithChildren =
  AuthenticatedSystemCompanyRouteRoute._addFileChildren(
    AuthenticatedSystemCompanyRouteRouteChildren,
  )

interface AuthenticatedSystemTenantSettingsRouteRouteChildren {
  AuthenticatedSystemTenantSettingsIndexRoute: typeof AuthenticatedSystemTenantSettingsIndexRoute
  AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute
  AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute
  AuthenticatedSystemTenantSettingsRolesRoleIdRoute: typeof AuthenticatedSystemTenantSettingsRolesRoleIdRoute
  AuthenticatedSystemTenantSettingsRolesNewRoute: typeof AuthenticatedSystemTenantSettingsRolesNewRoute
  AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute: typeof AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute
  AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute: typeof AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute
  AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute: typeof AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute
  AuthenticatedSystemTenantSettingsRolesIndexRoute: typeof AuthenticatedSystemTenantSettingsRolesIndexRoute
  AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute
  AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute
  AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute: typeof AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute
}

const AuthenticatedSystemTenantSettingsRouteRouteChildren: AuthenticatedSystemTenantSettingsRouteRouteChildren =
  {
    AuthenticatedSystemTenantSettingsIndexRoute:
      AuthenticatedSystemTenantSettingsIndexRoute,
    AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute:
      AuthenticatedSystemTenantSettingsCompanyDepartmentsDepartmentIdRoute,
    AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute:
      AuthenticatedSystemTenantSettingsCompanyDepartmentsNewRoute,
    AuthenticatedSystemTenantSettingsRolesRoleIdRoute:
      AuthenticatedSystemTenantSettingsRolesRoleIdRoute,
    AuthenticatedSystemTenantSettingsRolesNewRoute:
      AuthenticatedSystemTenantSettingsRolesNewRoute,
    AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute:
      AuthenticatedSystemTenantSettingsCompanyDepartmentsIndexRoute,
    AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute:
      AuthenticatedSystemTenantSettingsDocumentCategoriesIndexRoute,
    AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute:
      AuthenticatedSystemTenantSettingsGpsIntegrationsIndexRoute,
    AuthenticatedSystemTenantSettingsRolesIndexRoute:
      AuthenticatedSystemTenantSettingsRolesIndexRoute,
    AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute:
      AuthenticatedSystemTenantSettingsHangTagCheckListChecklistIdRoute,
    AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute:
      AuthenticatedSystemTenantSettingsHangTagCheckListNewRoute,
    AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute:
      AuthenticatedSystemTenantSettingsHangTagCheckListIndexRoute,
  }

const AuthenticatedSystemTenantSettingsRouteRouteWithChildren =
  AuthenticatedSystemTenantSettingsRouteRoute._addFileChildren(
    AuthenticatedSystemTenantSettingsRouteRouteChildren,
  )

interface AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteChildren {
  AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute
  AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute
}

const AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteChildren: AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteChildren =
  {
    AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute:
      AuthenticatedSystemTenantBuslinesBuslineIdIndexRoute,
    AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute:
      AuthenticatedSystemTenantBuslinesBuslineIdActingIndexRoute,
  }

const AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteWithChildren =
  AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute._addFileChildren(
    AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteChildren,
  )

interface AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteChildren {
  AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute
  AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute
}

const AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteChildren: AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteChildren =
  {
    AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute:
      AuthenticatedSystemTenantCompaniesCompanyIdUsersRoute,
    AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute:
      AuthenticatedSystemTenantCompaniesCompanyIdIndexRoute,
  }

const AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteWithChildren =
  AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute._addFileChildren(
    AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteChildren,
  )

interface AuthenticatedSystemTenantRouteRouteChildren {
  AuthenticatedSystemTenantSettingsRouteRoute: typeof AuthenticatedSystemTenantSettingsRouteRouteWithChildren
  AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute: typeof AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteWithChildren
  AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute: typeof AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteWithChildren
  AuthenticatedSystemTenantBuslinesImportsRoute: typeof AuthenticatedSystemTenantBuslinesImportsRoute
  AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute: typeof AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute
  AuthenticatedSystemTenantActingsIndexRoute: typeof AuthenticatedSystemTenantActingsIndexRoute
  AuthenticatedSystemTenantBuslinesIndexRoute: typeof AuthenticatedSystemTenantBuslinesIndexRoute
  AuthenticatedSystemTenantCompaniesIndexRoute: typeof AuthenticatedSystemTenantCompaniesIndexRoute
  AuthenticatedSystemTenantDocumentRequestsIndexRoute: typeof AuthenticatedSystemTenantDocumentRequestsIndexRoute
  AuthenticatedSystemTenantFleetsIndexRoute: typeof AuthenticatedSystemTenantFleetsIndexRoute
  AuthenticatedSystemTenantNpsIndexRoute: typeof AuthenticatedSystemTenantNpsIndexRoute
  AuthenticatedSystemTenantActingsActingIdIndexRoute: typeof AuthenticatedSystemTenantActingsActingIdIndexRoute
}

const AuthenticatedSystemTenantRouteRouteChildren: AuthenticatedSystemTenantRouteRouteChildren =
  {
    AuthenticatedSystemTenantSettingsRouteRoute:
      AuthenticatedSystemTenantSettingsRouteRouteWithChildren,
    AuthenticatedSystemTenantBuslinesBuslineIdRouteRoute:
      AuthenticatedSystemTenantBuslinesBuslineIdRouteRouteWithChildren,
    AuthenticatedSystemTenantCompaniesCompanyIdRouteRoute:
      AuthenticatedSystemTenantCompaniesCompanyIdRouteRouteWithChildren,
    AuthenticatedSystemTenantBuslinesImportsRoute:
      AuthenticatedSystemTenantBuslinesImportsRoute,
    AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute:
      AuthenticatedSystemTenantDocumentRequestsDocumentRequestIdRoute,
    AuthenticatedSystemTenantActingsIndexRoute:
      AuthenticatedSystemTenantActingsIndexRoute,
    AuthenticatedSystemTenantBuslinesIndexRoute:
      AuthenticatedSystemTenantBuslinesIndexRoute,
    AuthenticatedSystemTenantCompaniesIndexRoute:
      AuthenticatedSystemTenantCompaniesIndexRoute,
    AuthenticatedSystemTenantDocumentRequestsIndexRoute:
      AuthenticatedSystemTenantDocumentRequestsIndexRoute,
    AuthenticatedSystemTenantFleetsIndexRoute:
      AuthenticatedSystemTenantFleetsIndexRoute,
    AuthenticatedSystemTenantNpsIndexRoute:
      AuthenticatedSystemTenantNpsIndexRoute,
    AuthenticatedSystemTenantActingsActingIdIndexRoute:
      AuthenticatedSystemTenantActingsActingIdIndexRoute,
  }

const AuthenticatedSystemTenantRouteRouteWithChildren =
  AuthenticatedSystemTenantRouteRoute._addFileChildren(
    AuthenticatedSystemTenantRouteRouteChildren,
  )

interface AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteChildren {
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute
}

const AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteChildren: AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteChildren =
  {
    AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute:
      AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewPermissionsRoute,
    AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute:
      AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewIndexRoute,
  }

const AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteWithChildren =
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute._addFileChildren(
    AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteChildren,
  )

interface AuthenticatedSystemRouteRouteChildren {
  AuthenticatedSystemCompanyRouteRoute: typeof AuthenticatedSystemCompanyRouteRouteWithChildren
  AuthenticatedSystemTenantRouteRoute: typeof AuthenticatedSystemTenantRouteRouteWithChildren
  AuthenticatedSystemIndexRoute: typeof AuthenticatedSystemIndexRoute
  AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute: typeof AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute
  AuthenticatedSystemBuslineSchedulesIndexRoute: typeof AuthenticatedSystemBuslineSchedulesIndexRoute
  AuthenticatedSystemDocumentsIndexRoute: typeof AuthenticatedSystemDocumentsIndexRoute
  AuthenticatedSystemProfileIndexRoute: typeof AuthenticatedSystemProfileIndexRoute
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteWithChildren
  AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute: typeof AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute
}

const AuthenticatedSystemRouteRouteChildren: AuthenticatedSystemRouteRouteChildren =
  {
    AuthenticatedSystemCompanyRouteRoute:
      AuthenticatedSystemCompanyRouteRouteWithChildren,
    AuthenticatedSystemTenantRouteRoute:
      AuthenticatedSystemTenantRouteRouteWithChildren,
    AuthenticatedSystemIndexRoute: AuthenticatedSystemIndexRoute,
    AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute:
      AuthenticatedSystemBuslineSchedulesBuslineScheduleIdRoute,
    AuthenticatedSystemBuslineSchedulesIndexRoute:
      AuthenticatedSystemBuslineSchedulesIndexRoute,
    AuthenticatedSystemDocumentsIndexRoute:
      AuthenticatedSystemDocumentsIndexRoute,
    AuthenticatedSystemProfileIndexRoute: AuthenticatedSystemProfileIndexRoute,
    AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRoute:
      AuthenticatedSystemDocumentsCompanyDocumentPublicIdDocumentOverviewRouteRouteWithChildren,
    AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute:
      AuthenticatedSystemDocumentsCompanyDocumentPublicIdRequestChangesIndexRoute,
  }

const AuthenticatedSystemRouteRouteWithChildren =
  AuthenticatedSystemRouteRoute._addFileChildren(
    AuthenticatedSystemRouteRouteChildren,
  )

interface AuthenticatedBackofficeCustomersCustomerIdRouteRouteChildren {
  AuthenticatedBackofficeCustomersCustomerIdGeneralRoute: typeof AuthenticatedBackofficeCustomersCustomerIdGeneralRoute
  AuthenticatedBackofficeCustomersCustomerIdMembersRoute: typeof AuthenticatedBackofficeCustomersCustomerIdMembersRoute
  AuthenticatedBackofficeCustomersCustomerIdIndexRoute: typeof AuthenticatedBackofficeCustomersCustomerIdIndexRoute
}

const AuthenticatedBackofficeCustomersCustomerIdRouteRouteChildren: AuthenticatedBackofficeCustomersCustomerIdRouteRouteChildren =
  {
    AuthenticatedBackofficeCustomersCustomerIdGeneralRoute:
      AuthenticatedBackofficeCustomersCustomerIdGeneralRoute,
    AuthenticatedBackofficeCustomersCustomerIdMembersRoute:
      AuthenticatedBackofficeCustomersCustomerIdMembersRoute,
    AuthenticatedBackofficeCustomersCustomerIdIndexRoute:
      AuthenticatedBackofficeCustomersCustomerIdIndexRoute,
  }

const AuthenticatedBackofficeCustomersCustomerIdRouteRouteWithChildren =
  AuthenticatedBackofficeCustomersCustomerIdRouteRoute._addFileChildren(
    AuthenticatedBackofficeCustomersCustomerIdRouteRouteChildren,
  )

interface AuthenticatedBackofficeRouteRouteChildren {
  AuthenticatedBackofficeIndexRoute: typeof AuthenticatedBackofficeIndexRoute
  AuthenticatedBackofficeCustomersCustomerIdRouteRoute: typeof AuthenticatedBackofficeCustomersCustomerIdRouteRouteWithChildren
  AuthenticatedBackofficeCustomersIndexRoute: typeof AuthenticatedBackofficeCustomersIndexRoute
}

const AuthenticatedBackofficeRouteRouteChildren: AuthenticatedBackofficeRouteRouteChildren =
  {
    AuthenticatedBackofficeIndexRoute: AuthenticatedBackofficeIndexRoute,
    AuthenticatedBackofficeCustomersCustomerIdRouteRoute:
      AuthenticatedBackofficeCustomersCustomerIdRouteRouteWithChildren,
    AuthenticatedBackofficeCustomersIndexRoute:
      AuthenticatedBackofficeCustomersIndexRoute,
  }

const AuthenticatedBackofficeRouteRouteWithChildren =
  AuthenticatedBackofficeRouteRoute._addFileChildren(
    AuthenticatedBackofficeRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSystemRouteRoute: typeof AuthenticatedSystemRouteRouteWithChildren
  AuthenticatedBackofficeRouteRoute: typeof AuthenticatedBackofficeRouteRouteWithChildren
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
  AuthenticatedDocsDocumentRequestDocumentRequestIdRoute: typeof AuthenticatedDocsDocumentRequestDocumentRequestIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSystemRouteRoute: AuthenticatedSystemRouteRouteWithChildren,
  AuthenticatedBackofficeRouteRoute:
    AuthenticatedBackofficeRouteRouteWithChildren,
  AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  AuthenticatedDocsDocumentRequestDocumentRequestIdRoute:
    AuthenticatedDocsDocumentRequestDocumentRequestIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  DocsPublicIdRoute: DocsPublicIdRoute,
  PoliticasGetsempliceMotoristaRoute: PoliticasGetsempliceMotoristaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
